import React, { useState, useEffect } from 'react';
import './LegalPages.css';

const API_BASE = 'https://api.shanganxiaokao.com';
const DOC_URLS = {
    privacy: `${API_BASE}/api-docs/privacy`,
    agreement: `${API_BASE}/api-docs/agreement`,
};

function LegalPages() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [privacyHtml, setPrivacyHtml] = useState('');
    const [agreementHtml, setAgreementHtml] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const toggleMenu = () => setMenuOpen(prev => !prev);
    const closeMenu = () => setMenuOpen(false);

    // 从接口拉取 HTML 并提取 <body> 内容
    useEffect(() => {
        let cancelled = false;

        async function fetchDoc(url) {
            const res = await fetch(url);
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const html = await res.text();
            // 提取 <body>...</body> 之间的内容
            const match = html.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
            return match ? match[1].trim() : html;
        }

        (async () => {
            setLoading(true);
            setError('');
            try {
                const [pHtml, aHtml] = await Promise.all([
                    fetchDoc(DOC_URLS.privacy),
                    fetchDoc(DOC_URLS.agreement),
                ]);
                if (!cancelled) {
                    setPrivacyHtml(pHtml);
                    setAgreementHtml(aHtml);
                    setLoading(false);
                }
            } catch (err) {
                console.error('加载法律文档失败:', err);
                if (!cancelled) {
                    setError('加载失败，请刷新页面重试');
                    setLoading(false);
                }
            }
        })();

        return () => { cancelled = true; };
    }, []);

    return (
        <div className="legal-container">
            {/* 导航栏 - 与首页一致，支持手机端汉堡菜单 */}
            <nav className="navbar">
                <div className="navbar-logo">
                    <h2>上岸消考</h2>
                </div>
                <button
                    className={`navbar-toggle ${menuOpen ? 'open' : ''}`}
                    onClick={toggleMenu}
                    aria-label="菜单"
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
                <div className={`navbar-menu ${menuOpen ? 'open' : ''}`}>
                    <a href="/" onClick={closeMenu}>首页</a>
                    <a href="/#features" onClick={closeMenu}>软件特色</a>
                    <a href="/#download" onClick={closeMenu}>立即下载</a>
                </div>
            </nav>

            {/* 主要内容 */}
            <div className="legal-content">
                <div className="legal-card">
                    {loading && (
                        <div style={{ textAlign: 'center', padding: '4rem 0', color: '#9ca3af' }}>
                            <div className="legal-loading-spinner"></div>
                            <p style={{ marginTop: '1rem' }}>加载中…</p>
                        </div>
                    )}

                    {error && (
                        <div style={{ textAlign: 'center', padding: '4rem 0', color: '#ef4444' }}>
                            <p>{error}</p>
                        </div>
                    )}

                    {!loading && !error && (
                        <>
                            {/* 隐私政策 */}
                            <div
                                id="privacy"
                                className="legal-section"
                                dangerouslySetInnerHTML={{ __html: privacyHtml }}
                            />

                            <div className="legal-divider"></div>

                            {/* 用户协议 */}
                            <div
                                id="agreement"
                                className="legal-section"
                                dangerouslySetInnerHTML={{ __html: agreementHtml }}
                            />
                        </>
                    )}
                </div>
            </div>

            {/* 底部 */}
            <footer className="footer">
                <p>© 2026 上岸消考 版权所有 | 专注中级消防设施操作员考试上岸</p>
            </footer>
        </div>
    );
}

export default LegalPages;
